import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import CommandPalette from './components/CommandPalette/CommandPalette';
import Header from './components/Header/Header';

import ComingSoon from './pages/ComingSoon/ComingSoon';
import Dashboard from './pages/Dashboard/Dashboard';
import MarketResearch from './pages/MarketResearch/MarketResearch';
import NicheFinder from './pages/NicheFinder/NicheFinder';
import MarketValidation from './pages/MarketValidation/MarketValidation';
import CostEstimation from './pages/CostEstimation/CostEstimation';
import ReportGeneration from './pages/ReportGeneration/ReportGeneration';
import IdeaRefinement from './pages/IdeaRefinement/IdeaRefinement';
import LandingFlow from './pages/LandingFlow/LandingFlow';
import Sidebar from './components/Sidebar/Sidebar';
import './App.css';

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [hasIdea, setHasIdea] = useState(true);
  const [isCmdkOpen, setIsCmdkOpen] = useState(false);

  // Handle keyboard shortcut
  useEffect(() => {
    const down = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setIsCmdkOpen((open) => !open);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  return (
    <Router>
      <Analytics />
      <ComingSoon />
      {
      // hasIdea ? (
      //   <div className={`bg-neutral-700 grid ${
      //     isCollapsed ? 'grid-cols-[64px,1fr]' : 'grid-cols-[280px,1fr]'
      //   } h-screen overflow-hidden transition-all duration-300`}>
      //     <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      //     <div className="overflow-auto p-4 flex flex-col bg-neutral-900">
      //       <Header onOpenSearch={() => setIsCmdkOpen(true)} />
      //       <main className="rounded-lg">
      //         <Routes>
      //           <Route path="/dashboard" element={<Dashboard />} />
      //           <Route path="/market-research" element={<MarketResearch />} />
      //           <Route path="/niche-finder" element={<NicheFinder />} />
      //           <Route path="/market-validation" element={<MarketValidation />} />
      //           <Route path="/cost-estimation" element={<CostEstimation />} />
      //           <Route path="/report-generation" element={<ReportGeneration />} />
      //           <Route path="/idea-refinement" element={<IdeaRefinement />} />
      //           <Route path="*" element={<Navigate to="/dashboard" replace />} />
      //         </Routes>
      //       </main>
      //     </div>
      //     <CommandPalette isOpen={isCmdkOpen} setIsOpen={setIsCmdkOpen} />
      //   </div>
      // ) : (
        // <Routes>
        //   <Route 
        //     path="*" 
        //     element={<LandingFlow onIdeaSubmit={() => setHasIdea(true)} />} 
        //   />
        // </Routes>
      // )
      }
    </Router>
  );
}

export default App;
